import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=11490e3f&"
import script from "./ChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11490e3f')) {
      api.createRecord('11490e3f', component.options)
    } else {
      api.reload('11490e3f', component.options)
    }
    module.hot.accept("./ChangeEmail.vue?vue&type=template&id=11490e3f&", function () {
      api.rerender('11490e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/ChangeEmail/ChangeEmail.vue"
export default component.exports